import { render, staticRenderFns } from "./BriefModeBanner.vue?vue&type=template&id=2b13bfc4&scoped=true"
import script from "./BriefModeBanner.vue?vue&type=script&lang=js"
export * from "./BriefModeBanner.vue?vue&type=script&lang=js"
import style0 from "./BriefModeBanner.vue?vue&type=style&index=0&id=2b13bfc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b13bfc4",
  null
  
)

export default component.exports